export default {
  environmentalTitle: {
    id: 'rm_impact_intro_environmental_title',
    defaultMessage: 'The Environmental Cost',
  },
  environmentalDescription: {
    id: 'rm_impact_intro_environmental_description',
    defaultMessage:
      'Your phone is heavier than you think: what’s left behind by extraction are forever-scarred landscapes, polluted soil, poisoned water, and unbreathable air.',
  },
  humanTitle: {
    id: 'rm_impact_intro_human_title',
    defaultMessage: 'The Human Toll',
  },
  humanDescription: {
    id: 'rm_impact_intro_human_description',
    defaultMessage:
      'Your phone is heavier than you think. Behind every ping, alert, and notification is a child mining cobalt, a worker breathing toxins, and a family trapped in a conflict zone.',
  },
  geopoliticalTitle: {
    id: 'rm_impact_intro_geopolitical_title',
    defaultMessage: 'The Global Fallout',
  },
  geopoliticalDescription: {
    id: 'rm_impact_intro_geopolitical_description',
    defaultMessage:
      'Your phone is heavier than you think. The fight for supply chain dominance pits countries against each other, sparking geopolitical tensions, land grabs, and even war.',
  },
} as const
